import { render, staticRenderFns } from "./DataRecordDetail.vue?vue&type=template&id=be0bb2e2"
import script from "./DataRecordDetail.vue?vue&type=script&lang=js"
export * from "./DataRecordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports